// src\components\Pages\Home.jsx
import { useEffect } from 'react';
import Card from '../Card';
import ReelMarquee from '../../components/ReelMarquee/ReelMarquee';
import FunFact from '../FunFact';
import Hero from '../Hero';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PortfolioSlider from '../Slider/PortfolioSlider';
import Accordion from '../Accordion'
import PostSlider from '../Slider/PostSlider';
import SocialSlider from '../Slider/SocialSliderTemp';
import TestimonialSlider from '../Slider/TestimonialSlider';
import TeamSlider from '../Slider/TeamSlider';
import VideoModal from '../VideoModal';
import TimelineSlider from '../Slider/TimelineSlider';
import { pageTitle } from '../../helper';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SuccessStories from "../SuccessStories/SuccessStories";


// Hero Social Links
// const heroSocialLinks = [
//   {
//     name: 'Behance',
//     links: '/',
//   },
//   {
//     name: 'Twitter',
//     links: '/',
//   },
// ];


// FunFact Data
const funfaceData = [
  {
    title: "Time Saved",
    startNumber: 0,
    endNumber: 1200,
    speed: 50,    // ⭐ slower sliding
    suffix: "Hr+",
  },
  {
    title: "Organic Views",
    startNumber: 0,
    endNumber: 100,
    speed: 50,    // ⭐ very slow slide
    suffix: "M+",
  },
  {
    title: "Credibility",
    startNumber: 5,
    endNumber: 10,
    speed: 50,
    suffix: "X",
  },
];

const portfolioData = [
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/reels/reel1.gif',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_2.jpeg',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_0.jpg',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_3.jpeg',
  },
];

export default function Home() {
  pageTitle('Home');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="Growth on Autopilot"
        subtitle="We run your entire content system so people trust you, remember your brand, and inbound opportunities keep compounding, even when you’re offline."
      
      />
          
      {/* ✅ REEL MARQUEE SHOWING HERE */}
      <Div className="container-fluid">
        <Spacing lg="50" md="50" />
        <ReelMarquee />
      </Div>
      <Spacing lg="50" md="50" />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          data={funfaceData} variant="cs-type1" 
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Spacing lg="100" md="50" />
     <Div id="service">
        <Div className="container">
          <Div className="row">

            <Div className="col-xl-6 col-lg-6 col-md-12">
              <Div className="service-box">
                <h3>Content Production </h3>
                <p>
Professional photos and videos for businesses, events, products, and people—captured and edited with a cinematic, elegant touch.                </p>
                <a href="#" className="service-btn">Explore</a>
              </Div>
            </Div>

            <Div className="col-xl-6 col-lg-6 col-md-12">
              <Div className="service-box">
                <h3>Company</h3>
                <p>
                  We create and run a content system that keeps your company visible, talked about, and top of mind basically, word of mouth on autopilot.
                </p>
                <a href="#" className="service-btn">Explore</a>
              </Div>
            </Div>

            <Div className="col-xl-6 col-lg-6 col-md-12">
              <Div className="service-box">
                <h3>Founder</h3>
                <p>
                  If you want people to trust you, they need to see you. We help you build a strong personal brand on Instagram and LinkedIn, consistent content that actually makes you look like a leader.
                </p>
                <a href="#" className="service-btn">Explore</a>
              </Div>
            </Div>

            <Div className="col-xl-6 col-lg-6 col-md-12">
              <Div className="service-box">
                <h3>Website</h3>
                <p>
                  Your digital home that turns attention into revenue. A high-conversion website built to make your brand look credible, modern, and impossible to ignore.
                </p>
                <a href="#" className="service-btn">Explore</a>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      {/* Start LogoList Section */}
        <Div className="container-fluid">
          <LogoList />
        </Div>
      {/* End LogoList Section */}

      {/* Start Faq Section */}
        <Div className="container cs-shape_wrap_4">
          <Div className="row justify-content-center text-center">
            <Div className="col-lg-8">
              <SectionHeading
                title='Your questions, answered'
                subtitle='frequently asked'
              />
              <Spacing lg='50' md='50' />
            </Div>
          </Div>

          <Div className="row justify-content-center">
            <Div className="col-lg-8">
              <Accordion />
            </Div>
          </Div>
        </Div>
      <Spacing lg='50' md='50'/>

      {/* End Faq Section */}

      {/* Start story Section */}
        <Div className="container-fluid">
          <SuccessStories />   {/* 👈 Add here */}
        </Div>
      {/* End story Section */}


      {/* Start Portfolio Section */}
      {/* <Spacing lg="150" md="50" />
      <Div>
        <Div className="container">
          <SectionHeading
            title="Portfolio to explore"
            subtitle="Latest Projects"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <PortfolioSlider data={portfolioData} />
      </Div> */}
      {/* End Portfolio Section */}

      {/* Start Awards Section */}
      {/* <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="We get multiple awards"
                subtitle="Our Awards"
                variant="cs-style1"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div> */}
      {/* End Awards Section */}

      {/* Start Video Block Section */}
      {/* <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
          Our agile process is ability to adapt and respond to change. Agile
          organizations view change as an opportunity, not a threat.
        </h2>
        <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=VcaAVWtP48A"
          bgUrl="/images/video_bg.jpeg"
        />
      </Div> */}
      {/* End Video Block Section */}

      {/* Start Team Section */}
      {/* <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      <Spacing lg="90" md="45" /> */}
      {/* End Team Section */}

      {/* Start social slider Section */}
      {/* <Spacing lg="0" md="0" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Explore recent publication"
                subtitle="Our Social Media"
                btnText="View More"
                btnLink="/social"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <SocialSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
       <Spacing lg="100" md="45" /> */}
      {/* End socila slider Section */}

      {/* Start Testimonial Section */}
      {/* <TestimonialSlider /> */}
      {/* End Testimonial Section */}


      {/* Start Blog Section */}
      {/* <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Explore recent publication"
                subtitle="Our Blog"
                btnText="View More Blog"
                btnLink="/blog"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <PostSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div> */}
      {/* End Blog Section */}

      {/* Start MovingText Section */}
      {/* <Spacing lg="125" md="70" />
      <MovingText text="Our reputed world wide partners" />
      <Spacing lg="105" md="70" /> */}
      {/* End MovingText Section */}

      {/* Start CTA Section */}
      {/* <Div className="container">
        <Cta
          title="Let’s disscuse make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div> */}
      {/* End CTA Section */}
    </>
  );
}
